import { useMutation, useQueryClient } from '@tanstack/react-query'

import { getProfileClientMedicalSheetQueryKey } from '@/ui/hooks/queries/useProfileClientMedicalSheetQuery '

import { responsibleMedicalRecordInstance } from '../..'
import { UpdateResponsibleMedicalRecordDTO } from '../../domain/models/UpdateMedicalRecordDTO'
import { getListResponsibleMedicalRecordQueryKey } from './useListResponsibleMedicalRecordQuery'
import { getResponsibleMedicalRecordQueryKey } from './useResponsibleMedicalRecordQuery'

export function getReviewResponsibleMedicalRecordMutationKey() {
  return ['reviewResponsibleMedicalRecord']
}

export function useReviewResponsibleMedicalRecordMutation({
  onSuccess,
  onError
}: {
  onSuccess?: () => void
  onError?: () => void
} = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: getReviewResponsibleMedicalRecordMutationKey(),
    mutationFn: async (params: {
      patientId: string
      responsibleMedicalRecordId: string
      data: UpdateResponsibleMedicalRecordDTO
    }) =>
      await responsibleMedicalRecordInstance.reviewResponsibleMedicalRecord(
        params
      ),
    onSuccess: (_, { responsibleMedicalRecordId, patientId }) => {
      queryClient.invalidateQueries({
        queryKey: getListResponsibleMedicalRecordQueryKey()
      })
      queryClient.invalidateQueries({
        queryKey: getProfileClientMedicalSheetQueryKey(patientId)
      })
      queryClient.invalidateQueries({
        queryKey: getResponsibleMedicalRecordQueryKey(
          responsibleMedicalRecordId
        )
      })
      onSuccess?.()
    },
    onError: () => {
      onError?.()
    }
  })
}
